import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import _ from 'lodash';
import Translate from '../common/Translate';
import useValue from '../../services/Form/useValue';
import ModalCustomCost from './ModalCustomCost';
import CarPhotoSlider from '../CarProfile/CarPhotoSlider';

const Boolean = (props) => {
  const { elementIds } = props;
  const { questionId, sectionId, formId } = elementIds;
  const { question, setDisableNav, goNextQuestion } = props;
  const defaultValue = question.default_value;
  const [value, setValue] = useValue(formId, sectionId, questionId, question.type, 'value', defaultValue);
  const [customCostModalShown, setCustomCostModalShown] = useState(false);
  const [showImage, setShowImage] = useState(false);

  const customCostKey = question.custom_cost;
  const addImageKey = question.add_picture;

  useEffect(() => {
    if (setDisableNav !== undefined) {
      if (value !== null && value !== '' && value !== undefined) setDisableNav(false);
      else setDisableNav(true);
    }
  });

  const setImageSliderDisplay = (option) => {
    if (!showImage && addImageKey === option) setShowImage(true);
    if (showImage && addImageKey !== option) setShowImage(false);
  };

  useEffect(() => {
    let option = value;
    if (typeof option === 'object' && option !== null) option = _.first(_.keys(option));
    setImageSliderDisplay(option);
  });

  function handleClick(option) {
    if (customCostKey === option) return setCustomCostModalShown(true);
    if (option === value) return setValue(null);
    setImageSliderDisplay(option);
    setValue(option);
    if (addImageKey !== option && typeof goNextQuestion === 'function') goNextQuestion();
    return null;
  }

  const closeModal = () => {
    setCustomCostModalShown(false);
  };

  const setCustomValues = (values) => {
    setValue(values);
    closeModal();
    const option = Object.keys(values)[0];
    if (addImageKey !== option && typeof goNextQuestion === 'function') goNextQuestion();
  };

  return (
    <>
      <ModalCustomCost
        isOpen={customCostModalShown}
        closeModal={closeModal}
        setCustomValues={setCustomValues}
        customCostKey={customCostKey}
        value={value}
        questionId={questionId}
      />
      {showImage && (
        <CarPhotoSlider
          formId={formId}
          sectionId={sectionId}
          questionId={questionId}
          questionType={question.type}
          resetState={() => {}}
        />
      )}
      <div className="question-boolean" data-cy={questionId}>
        <Row>
          <Col xs="6" md="3" lg="2">
            <button
              type="button"
              className={
                value &&
                (value === 'true' || (typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'true')))
                  ? 'btn btn-block btn-value mb-3 mr-3 selected'
                  : 'btn btn-block btn-value mb-3 mr-3'
              }
              value="true"
              data-cy="true"
              onClick={() => {
                handleClick('true');
              }}
            >
              <Translate code="yes" />
            </button>
          </Col>
          <Col xs="6" md="3" lg="2">
            <button
              type="button"
              className={
                value &&
                (value === 'false' ||
                  (typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'false')))
                  ? 'btn btn-block btn-value mb-3 mr-3 selected'
                  : 'btn btn-block btn-value mb-3 mr-3'
              }
              value="true"
              data-cy="true"
              onClick={() => {
                handleClick('false');
                if (typeof goNextQuestion === 'function') goNextQuestion();
              }}
            >
              <Translate code="no" />
            </button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Boolean;
Boolean.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['boolean']).isRequired,
    custom_cost: PropTypes.shape(),
    add_picture: PropTypes.shape(),
    default_value: PropTypes.string,
  }),
  elementIds: PropTypes.shape({
    questionId: PropTypes.string.isRequired,
    sectionId: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
  }).isRequired,
  setDisableNav: PropTypes.func,
  goNextQuestion: PropTypes.func,
};

Boolean.defaultProps = {
  question: {
    custom_cost: undefined,
    add_picture: undefined,
    default_value: null,
  },
  setDisableNav: undefined,
  goNextQuestion: undefined,
};
